module.exports = __webpack_public_path__ + "img/questioning.d90db53c.svg";